import { AppStateFailure, IStateSlice } from '@symphony-solo/shared/common-state/src';
import { BarcodeScannedAction } from '../+state';

export class ScannerState implements IStateSlice {
  public isLoading: boolean;
  public failures: AppStateFailure;
  public isScannerShown: boolean;
  public isScannerStarted: boolean;
  public isContinuousScan: boolean;
  public scannerShouldRestart: boolean;
  public isTemporaryClosed: boolean;
  public actionToDispatchOnBarcodeScanned: BarcodeScannedAction;

  constructor() {
    this.isLoading = false;
    this.failures = null;
    this.isScannerShown = false;
    this.isScannerStarted = false;
    this.isContinuousScan = false;
    this.scannerShouldRestart = false;
    this.isTemporaryClosed = false;
    this.actionToDispatchOnBarcodeScanned = null;
  }
}
